import { z } from 'zod';

export const formTemplateStatusSchema = z.enum([
  'draft',
  'published',
  'publishedDraft',
]);

export const formRuntimeStatusSchema = z.enum([
  'draft',
  'completed',
  'pendingReview',
  'pendingSignature',
  'pendingReviewAndSignature',
  'signed',
  'cancelled',
]);

export const formRuntimeTodoStatusSchema = z.enum([
  'pending',
  'draft',
  'completed',
  'cancelled',
]);
